export const LocalePickerMessages = {
  button: {
    id: 'MainLayout.Footer.LocalePicker.button',
    description: 'French',
  },
}
